var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"branding",style:(_vm.styles)},[_c('logo-n'),_c('heading',{attrs:{"level":3},domProps:{"innerHTML":_vm._s(_vm.category.label)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }